export default __webpack_public_path__ + "static/media/PremierIconDark.6117595b.svg";